import React, { useMemo } from 'react';
import { cloneDeep } from 'lodash';
import {
  StyledSection,
  StyledFlex,
  StyledTextPairing,
  StyledGridContainer,
  StyledCardWrapper,
} from '@sections/registry/ShopSection/ShopSection.styles';
import { SearchBar } from '@sections/shared/SearchBar';
import { Box } from '@components/Box';
import { GridView, RecommendProducts, StoreFront } from '@sections/shared/GridView';
import { registryPageData } from '@data-ts/pages/registry';
import { CurationCard, OneRegistryCard, RecommendedProducts, UniversalSearchCard } from './components';
const { shopSection, shopSearch } = registryPageData;

export const ShopSection: React.FC<{ products: RecommendProducts; isControlVersion?: boolean }> = ({
  products,
  isControlVersion = false,
}) => {
  const titleProps = isControlVersion
    ? ({ title: shopSearch.title, titleColor: 'neutra6', body: shopSearch.subTitle, bodyColor: 'neutra5', bodyVariant: 'dek24' } as const)
    : ({ title: shopSection.title, titleColor: 'mono1', body: shopSection.subTitle, bodyColor: 'mono1', bodyVariant: 'dek20' } as const);

  const formattedProducts = useMemo(() => {
    const productData = cloneDeep(products).filter(data => !!data.node.catalogItemGroupData.tileViewItem);
    return productData.slice(0, 8);
  }, [products]);

  return (
    <StyledSection as="section" id="RegistryShopSection" paddingTop={5} isControlVersion={isControlVersion}>
      <StyledFlex margin={'auto'} flexDirection="column" paddingX={[3, 0]} isControlVersion={isControlVersion}>
        <StyledTextPairing
          alignment="center"
          titleTagName="h2"
          titleVariant="hed56"
          marginBottom={7}
          isControlVersion={isControlVersion}
          {...titleProps}
        />
        {isControlVersion && (
          <SearchBar
            submitLabel={shopSearch.submitLabel}
            placeHolder={shopSearch.placeHolderV0}
            eventName="RegistrySearched"
            id="registry"
            enabledAmplitude={true}
          />
        )}
      </StyledFlex>
      {isControlVersion ? (
        <Box marginY={[9, 10]} paddingY={[0, 3]}>
          <GridView
            items={formattedProducts}
            itemPerLine={{ sm: 4, belowSm: 2 }}
            eventName="RegistryProductClicked"
            storeFront={StoreFront.wedding}
            enabledAmplitude={true}
          />
        </Box>
      ) : (
        <StyledGridContainer>
          <RecommendedProducts products={products} />
          <StyledCardWrapper>
            <OneRegistryCard />
            <CurationCard />
            <UniversalSearchCard />
          </StyledCardWrapper>
        </StyledGridContainer>
      )}
    </StyledSection>
  );
};
